import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchInsertEthicsTeamGroup } from "./helpAndAssistantApi";
import swal from 'sweetalert';
export interface insertEthicsTeamGroupState {
  insertEthicsTeamGroup: any;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: insertEthicsTeamGroupState = {
  insertEthicsTeamGroup: [],
  status: "idle",
};

export const GetinsertEthicsTeamGroup = createAsyncThunk(
  "insertEthicsTeamGroup",
  async (data: any) => {
    const response = await fetchInsertEthicsTeamGroup(data);
    return response;
  }
);

export const insertEthicsTeamGroupSlice = createSlice({
  name: "insertEthicsTeamGroup",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetinsertEthicsTeamGroup.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetinsertEthicsTeamGroup.rejected, (state, action) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetinsertEthicsTeamGroup.fulfilled, (state, action) => {
        state.status = "success";
        state.insertEthicsTeamGroup = action.payload;
        swal("Record saved success!",  "success");
      });
  },
});

export const {} = insertEthicsTeamGroupSlice.actions;

export const selectinsertEthicsTeamGroup = (state: RootState) => {
  return state.InsertEthicsTeamGroup.insertEthicsTeamGroup;
};

export default insertEthicsTeamGroupSlice.reducer;
